<template>
<div :class="$style['turn-down']">
    <table>
            <pt-form-list-item label="驳回理由" :required="true">
                <wt-input :class="$style['reject-message']" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="form.rejectRemark"></wt-input>
            </pt-form-list-item>
    </table>
    <div class="button-div">
        <el-button type="primary" @click="turnDown" :loading="loading">驳回</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
</div>
</template>
<script>
export default {
  props: {
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isIntegralRefund: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    titleLabel () {
      return this.isIntegralRefund ? '退还积分' : '退款'
    }
  },
  data () {
    return {
      form: {

      },
      loading: false
    }
  },
  methods: {
    turnDown () {
      if (this.isIntegralRefund) {
        this.form.pointsOrderId = this.orderDetail.id
        this.form.remark = this.form.rejectRemark
        this.$delete(this.form, 'rejectRemark')
      } else {
        this.form.mallOrderId = this.orderDetail.id
      }
      let ajaxUrl = this.isIntegralRefund ? 'rejectRefundmentIntegral' : 'rejectRefundment'
      if (this.form.rejectRemark || this.form.remark) {
        this.loading = true
        this.$store.dispatch(ajaxUrl, this.form).then(res => {
          this.loading = false
          this.$message.success('驳回' + this.titleLabel + '申请成功')
          this.$emit('close', true)
        }).catch(err => {
          this.loading = false
          this.$emit('close', true)
          this.$message.error(err || '驳回' + this.titleLabel + '失败')
        })
      } else {
        this.$message.error('请填写驳回理由')
      }
    },
    cancel () {
      this.$emit('close')
    }
  }
}
</script>
<style module lang="less">
.turn-down{
:global
table{
    tr{
        td{
        &:first-child{
                display: flex;
                justify-content: flex-end;
            }
        }
    }
}
}
.reject-message{
    :global
    textarea{
   color:#222!important
    }
}
</style>
